import { libHabitat } from './index';
export var prefix = 'modelportfolios/'; // tech debt lowercase `p` in portfolios
export var IDToName = function (id) {
    return libHabitat.IDToName(id) + '/' + prefix + id.modelPortfolioID;
};
